import React from 'react';
import { View, Text } from 'react-native';
import styles from '../../styles/pages/projectstatusStyles';
import { ProgressStagesProps } from '../../types/projectstatus';

const formatDoneRatio = (value: number | string): string => {
  // 숫자로 변환
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // 정수인 경우 소수점 제거
  if (Number.isInteger(numValue)) {
    return numValue.toString();
  }
  
  // 소수점이 있는 경우 그대로 표시
  return numValue.toString();
};

const ProgressStages = ({ project }: ProgressStagesProps) => {
  if (!project.progressData) {
    return null;
  }

  return (
    <View style={styles.stagesContainer}>
      {project.progressData.map((item) => (
        <View key={item.id} style={styles.stageItem}>
          <Text style={styles.stageText}>{item.subject}</Text>
          <View style={styles.progressBar}>
            <View
              style={[
                styles.progressFill,
                { width: `${item.done_ratio}%` }
              ]}
            />
          </View>
          <Text style={styles.percentageText}>{formatDoneRatio(item.done_ratio)}%</Text>
        </View>
      ))}
    </View>
  );
};

export default ProgressStages;